import { cn } from "@/lib/utils";

/**
 * Standard content container for all dashboard pages.
 * Usage:
 *   <PageContainer>...</PageContainer>               // default: max-w 960px
 *   <PageContainer size="narrow">...</PageContainer> // max-w 600px (forms, billing)
 *   <PageContainer size="wide">...</PageContainer>   // max-w 1280px (tables, admin)
 */
function PageContainer({ size = "default", className, children }) {
  return (
    <div className={cn(
      "px-10 py-9 max-md:px-4 max-md:py-5 mx-auto w-full",
      size === "narrow" && "max-w-[600px]",
      size === "default" && "max-w-[960px]",
      size === "wide"    && "max-w-[1280px]",
      className
    )}>
      {children}
    </div>
  );
}

export { PageContainer };
